import { render, staticRenderFns } from "./CartNotifications.vue?vue&type=template&id=422e7792&scoped=true&"
import script from "./CartNotifications.vue?vue&type=script&lang=ts&"
export * from "./CartNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./CartNotifications.vue?vue&type=style&index=0&id=422e7792&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e7792",
  null
  
)

export default component.exports